/* eslint-disable no-unused-vars */

import React from "react";
import ScrollableModal from "../../../../../components/Universal/ScrollableModal.component";
import { Helmet } from "react-helmet";
import PageHeader from "../../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import DropDownInput from "../../../../../components/Universal/DropDownInput.component";
import FormInput from "../../../../../components/Universal/FormInput.component";
import { Formik } from "formik";
import CustomBill from "../../../../../components/Universal/CustomBill.component";
import VendorPaymentValidation from "../../../../../components/PagesComponents/Financial/CashOutFlow/AcademicEx/MaterialAndResources/VendorPaymentValidation.component";
import { ReactComponent as BsBoxArrowRight } from "../../../../../assets/Icons/Universal/BsBoxArrowRight.svg";
import DatePicker from "../../../../../components/Universal/DatePicker.component";
import SearchIcon from "../../../../../assets/Icons/Pages/Organizational/Management/Members/Search.svg";
import "../../../../../styles/Pages/Financial/CashOutFlow/AcademicEx/MaterialAndResources.style.css";
import AcademicUniversalTable from "../../../../../components/Universal/Tables/AcademicUniversalTable.component";
import UniversalTable from "../../../../../components/Universal/Tables/UniversalTable.component";
import * as Yup from "yup";
import "./MisellaneousCost.style.css";
import InfoSummaryCard from "./InfoSummaryCard.component";

export const MiscellaneousFeatureValidation = Yup.object().shape({
  featureName: Yup.string()
    .required("Feature name is required")
    .min(3, "Feature name must be at least 3 characters"),

  description: Yup.string()
    .required("Description is required")
    .min(5, "Description must be at least 5 characters"),

  totalAmount: Yup.number()
    .required("Total amount is required")
    .positive("Total amount must be greater than 0"),

  paidAmount: Yup.number()
    .required("Paid amount is required")
    .positive("Paid amount must be greater than 0")
    .max(Yup.ref("totalAmount"), "Paid amount cannot exceed total amount"),

  provider: Yup.string().nullable().max(50, "Provider name too long"),

  contact: Yup.string()
    .nullable()
    .matches(/^[0-9]*$/, "Contact must be digits only")
    .max(15, "Contact number too long"),

  paymentMode: Yup.string().required("Payment mode is required"),

  confirmedBy: Yup.string().required("Confirmed by is required"),

  gst: Yup.number()
    .nullable()
    .min(0, "GST must be 0 or greater")
    .max(100, "GST cannot exceed 100"),
});

const Body = ({
  teacherList,
  teacherTableHeaders,
  eventHistoryData,
  columns,
  confirmedByOptions,
  paymentModes,
}) => {
  const [isReceiptOpen, setIsReceiptOpen] = React.useState(false);
  const [checkedItems, setCheckedItems] = React.useState({});
  const [selectedData, setSelectedData] = React.useState(null);
  const [submittedValues, setSubmittedValues] = React.useState(null);
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [showHistory, setShowHistory] = React.useState(false);

  const handleFormSubmit = (values) => {
    // Add new entry to list
    setSubmittedValues(values);
  };

  console.log(submittedValues);

  const layout = [
    [
      { key: "featureName", label: "Feature name" },
      {
        key: "totalAmount",
        label: "Total amount (INR)",
        render: (val) => `₹ ${val?.toLocaleString()}`,
      },
      {
        key: "paidAmount",
        label: "Paid amount (INR)",
        render: (val) => `₹ ${val?.toLocaleString()}`,
      },
    ],
    [
      { key: "provider", label: "Provider" },
      { key: "contact", label: "Contact" },
      { key: "paymentMode", label: "Payment mode" },
    ],
    [
      { key: "description", label: "Description", span: 2 },
      { key: "confirmedBy", label: "Confirmed by" },
    ],
    [{ key: "gst", label: "GST", render: (val) => `${val}%` }],
  ];

  if (showHistory)
    return (
      <section className="ProfessionalDevelopmentSection">
        <ScrollableModal
          isOpen={isReceiptOpen}
          onClose={() => setIsReceiptOpen(!isReceiptOpen)}
        >
          {isReceiptOpen && (
            <CustomBill data={selectedData} vendorInfo={submittedValues} />
          )}
        </ScrollableModal>
        <Helmet>
          <title>All payments history</title>
          <meta
            name="description"
            content="Monitor and analyze cash inflow trends and contributions."
          />
          <meta
            name="keywords"
            content="All payments history, cash outflow, financial dashboard, cash flow analysis, business finance"
          />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Helmet>
        <PageHeader title={"All payments history"} />
        <div
          style={{
            marginTop: "1rem",
            backgroundColor: "white",
            padding: "2rem",
            borderRadius: "10px",
          }}
          className="HistorySection"
        >
          <div className="history-header mb-1">
            <h3
              style={{
                color: "var(--grayColor)",
                fontWeight: "500",
                marginBottom: "0.5rem",
              }}
            >
              All miscellaneous payment history
            </h3>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="inputs-buttons"
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "1rem" }}
                className="input"
              >
                <div className="searchInputContainer">
                  <button className="searchBtn">
                    <img src={SearchIcon} alt="Search" />
                  </button>
                  <input
                    type="text"
                    className="pageHeaderInput"
                    placeholder="Search id"
                  />
                </div>
                <DatePicker
                  label=""
                  name="date"
                  setFieldValue={() => {}}
                  placeholder={"Choose a date"}
                  errors={() => {}}
                />
              </div>
              <div style={{ display: "flex", gap: "1rem" }} className="buttons">
                <button
                  style={{
                    backgroundColor: "var(--blueColor1)",
                    borderColor: "var(--blueColor1)",
                  }}
                  onClick={() => setShowHistory(false)}
                  className="actionBtn"
                >
                  Go to miscellaneous costs
                </button>
                <button className="actionBtn">Download</button>
              </div>
            </div>
          </div>
          <div className="history-table">
            <UniversalTable
              columns={columns}
              data={eventHistoryData}
              maxBodyHeight="340px"
              footer={
                <div className="Amount-Indicators">
                  <div className="indicator-group">
                    <span className="indicator-box filled-orange">
                      Total count: <span className="text-white">236</span>
                    </span>

                    <span className="indicator-box outlined-orange">
                      Due amount:{" "}
                      <span className="text-orange">₹ 2,60,560</span>
                    </span>
                  </div>

                  <div className="indicator-group">
                    <span className="indicator-box outlined-blue">
                      Total amounts:{" "}
                      <span className="text-blue-light">₹ 2,60,560</span>
                    </span>

                    <span className="indicator-box filled-blue">
                      Paid amount:{" "}
                      <span className="text-white">₹ 2,60,560</span>
                    </span>
                  </div>
                </div>
              }
            />
          </div>
        </div>
      </section>
    );

  return (
    <section className="AcademicEventSection">
      <ScrollableModal
        isOpen={isReceiptOpen}
        onClose={() => setIsReceiptOpen(!isReceiptOpen)}
      >
        {isReceiptOpen && (
          <CustomBill data={selectedData} vendorInfo={submittedValues} />
        )}
      </ScrollableModal>
      <Helmet>
        <title>Miscellaneous costs</title>
        <meta
          name="description"
          content="Monitor and analyze cash inflow trends and contributions."
        />
        <meta
          name="keywords"
          content="Personality development,cash outflow, financial dashboard, cash flow analysis, business finance"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <PageHeader title={"Miscellaneous costs"} />
      <div className="MiscellaneousCostBody">
        <div className="left">
          <div style={{ width: "100%" }} className="formContaienr">
            <Formik
              initialValues={{
                featureName: "",
                description: "",
                totalAmount: "",
                paidAmount: "",
                provider: "",
                contact: "",
                paymentMode: "",
                confirmedBy: "",
                gst: "",
              }}
              validationSchema={MiscellaneousFeatureValidation}
              onSubmit={(values) => {
                console.log("Miscellaneous Feature Submitted:", values);
                handleFormSubmit(values);
                // setShowSuccess(true);
              }}
            >
              {({
                setFieldValue,
                handleSubmit,
                touched,
                errors,
                setTouched,
              }) => (
                <form
                  onSubmit={handleSubmit}
                  className="miscellaneousFeatureForm"
                >
                  <div
                    style={{ display: "grid", gridColumn: "1fr 1fr" }}
                    className="miscellaneousFeatureFormInputs"
                  >
                    {/* Feature name & Description */}
                    <FormInput
                      label="Feature name"
                      type="text"
                      name="featureName"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter feature name"
                      setFieldValue={(e) =>
                        setFieldValue("featureName", e.target.value)
                      }
                    />
                    <FormInput
                      label="Description"
                      type="text"
                      name="description"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter description about feature"
                      setFieldValue={(e) =>
                        setFieldValue("description", e.target.value)
                      }
                    />

                    {/* Total & Paid Amount */}
                    <FormInput
                      label="Total amount (INR)"
                      type="number"
                      name="totalAmount"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter amount"
                      setFieldValue={(e) =>
                        setFieldValue("totalAmount", e.target.value)
                      }
                    />
                    <FormInput
                      label="Paid amount (INR)"
                      type="number"
                      name="paidAmount"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter paid amount"
                      setFieldValue={(e) =>
                        setFieldValue("paidAmount", e.target.value)
                      }
                    />

                    {/* Provider & Contact */}
                    <FormInput
                      label="Provider (if any)"
                      type="text"
                      name="provider"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter provider name"
                      setFieldValue={(e) =>
                        setFieldValue("provider", e.target.value)
                      }
                    />
                    <FormInput
                      label="Contact (if any)"
                      type="text"
                      name="contact"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter provider contact number"
                      setFieldValue={(e) =>
                        setFieldValue("contact", e.target.value)
                      }
                    />

                    {/* Dropdowns */}
                    <DropDownInput
                      name="paymentMode"
                      label="Payment mode"
                      placeholder="Choose payment mode"
                      suggestionList={paymentModes}
                      setFieldValue={(val) => setFieldValue("paymentMode", val)}
                      touched={touched}
                      errors={errors}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                    />

                    <DropDownInput
                      name="confirmedBy"
                      label="Confirmed by"
                      placeholder="Choose confirmed by"
                      suggestionList={confirmedByOptions}
                      setFieldValue={(val) => setFieldValue("confirmedBy", val)}
                      touched={touched}
                      errors={errors}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                    />

                    {/* GST */}
                    <FormInput
                      label="GST (if any)"
                      type="number"
                      name="gst"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter GST in %"
                      setFieldValue={(e) =>
                        setFieldValue("gst", e.target.value)
                      }
                    />
                  </div>

                  <button type="submit" className="confirmPaymentBtn actionBtn">
                    Add to the list and collect fund
                  </button>
                </form>
              )}
            </Formik>
          </div>
        </div>
        <div className="right">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "1rem",
              borderBottom: "2px solid #ddd",
            }}
            className="content-header"
          >
            <h3>Confirmation of Payment</h3>
            <button
              onClick={() => setShowHistory(true)}
              className="blueActionBtnLight"
            >
              All Payments History
            </button>
          </div>

          {showSuccess ? (
            <div className="billSuccess">
              <h2>You have confirm payment successfully</h2>
              <p>Receipt ID: 23456789012</p>
              <h4 onClick={() => setIsReceiptOpen(true)}>
                Receipt <BsBoxArrowRight />
              </h4>
              <button
                onClick={() => setShowSuccess(false)}
                className="actionBtn"
              >
                Okay
              </button>
            </div>
          ) : (
            submittedValues != null && (
              <>
                <InfoSummaryCard
                  data={submittedValues}
                  layout={layout}
                  actionLabel="Confirm payment"
                  onAction={() => alert("Payment confirmed!")}
                />
              </>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default Body;
